<button mat-stroked-button *ngIf="selection == null" style="margin-bottom: 15px; width: 100%" (click)="onSearch()">
    {{ text }}
</button>
<div *ngIf="selection != null" style="margin-bottom: 15px"  matTooltip="{{selection.manufacturer}} -- {{selection.definition}} ">
    <strong>{{ selection.code }}</strong>
    <a (click)="onClear()" style="padding-left: 5px; color: brown; font-size: 100%; cursor: pointer; margin-left: 3%;">{{ "Clear" |
        localize }}</a>
    <br>{{ selection.definition | dotdotdot:25 }}
</div>